import { FC } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { IframeView } from '../common';

import { SearchDocument } from '@/_generated/api-clients/xp';

interface XylemeProps {
  /** Xyleme document. */
  document: SearchDocument;
}

/** Xyleme document. */
const Xyleme: FC<XylemeProps> = ({ document }) => {
  const { xylemeContentFromCdn } = useFlags();

  return (
    <IframeView
      url={xylemeContentFromCdn ? document.contentUrl : document.contentApiUrl}
    />
  );
};

export default Xyleme;
